export const AccordionElementWidgetId = 'AccordionElementWidget';

export enum AccordionElementWidgetAttributes {
  HEADLINE = 'headline',
  TEXT = 'text',
  ID = 'accordionId',
}
